module.exports = __webpack_public_path__ + "img/qtfw.681eb56.png";